import React, { useEffect, useRef, useState } from "react";
import cross from "../assets/images/cross.png";
import Password_Icon from "../assets/images/Password_Icon.png";
import { Icon } from "@iconify/react";
import { Modal } from "flowbite-react";
import axios from "axios";
import { toast } from "react-toastify";

function UserResetPassword(props) {
  const {
    openResetPasswordModal,
    setOpenResetPasswordModal,
    setOpenModal,
    setOpenRecoveryModal,
    email,
    otpString,
  } = props;
  const [showpassword, setshowpassword] = useState(false);
  const [showconfirmpassword, setshowconfirmpassword] = useState(false);
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [error, setError] = useState({});
  const modalRef2 = useRef();
  const passwordref = useRef(null);
  const confirmPasswordref = useRef(null);

  const validateResetPassword = async () => {
    let errors = {};

    if (!newPassword) {
      errors.newPassword = "Password is required";
    } else {
      if (!/(?=.*[a-z])/.test(newPassword)) {
        errors.newPassword = "At least 1 lowercase letter is required";
      }
      if (!/(?=.*[A-Z])/.test(newPassword)) {
        errors.newPassword = "At least 1 uppercase letter is required";
      }
      if (!/(?=.*\d)/.test(newPassword)) {
        errors.newPassword = "At least 1 number is required";
      }
      if (/[@$!%*?&]/) {
        error.newPassword =
          "Password must contain at least one Special characters";
      }
      if (newPassword.length < 8) {
        errors.newPassword = "Password must be at least 8 characters long";
      }
    }
    if (!confirmPassword) {
      errors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      errors.confirmPassword = "Passwords do not match";
    }

    setError(errors);

    if (Object.keys(errors).length === 0) {
      handleResetPassword();
    }
  };

  const handleResetPassword = async () => {
    axios
      .post("https://aipricingtool-python.onrender.com/reset_password", {
        email: email,
        code: otpString,
        new_password: newPassword,
        confirm_password: confirmPassword,
      })
      .then((response) => {
        console.log(response.data);
        toast.success("password Successfully updated");
        setOpenResetPasswordModal(false);
        setOpenModal(false);
        setOpenRecoveryModal(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("error updating password");
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      validateResetPassword();
    }
  };

  if (error.password) {
    passwordref.current.focus();
  } else if (error.confirmPassword) {
    confirmPasswordref.current.focus();
  }

  return (
    <Modal
      show={openResetPasswordModal}
      onClose={() => setOpenResetPasswordModal(false)}
      className="dashboard-modal bg-opacity-60 font-userFont text-[#E3D0A8]"
      size="2xl"
      ref={modalRef2}
    >
      <Modal.Body className="large   ">
        <div className="">
          <div className="sign_up_right_modal rounded-3xl py-4 lg:py-5 2xl:py-[20px] w-full  ">
            <div className="cross w-full flex justify-end cursor-pointer">
              <img
                onClick={() => setOpenResetPasswordModal(false)}
                src={cross}
                alt=""
              />
            </div>
            <div className=" max-w-[342px] m-auto text-center   2xl:h-auto mb-5 lg:mb-6  2xl:mb-[68px]">
              <h1 className=" text-[27px] Campton pb-[18px]">Reset Password</h1>
              <p className=" text-black">
                Set the new password for your account so you can login and
                access all the features.
              </p>
            </div>
            <div>
              <p className="flex text-[27px] Campton items-center justify-evenly  mb-4">
                Hey: <span className=" text-[24px] Campton "> {email} </span>
              </p>
              <div className="form-container flex flex-col gap-3 md:gap-4 2xl:gap-8  ">
                <div className="mb-4 input items-center  flex gap-3 border-2 !border-[#E3D0A8]   rounded-xl p-2 md:p-3 2xl:p-[22px] ">
                  {" "}
                  <img
                    src={Password_Icon}
                    className="w-4 h-4 md:h-auto md:w-auto"
                    alt=""
                  />
                  <input
                    className="border-none text-xl md:text-2xl text-black  focus:outline-none p-0  focus:ring-0 w-full placeholder:text-[#E3D0A8]  md:placeholder:text-2xl "
                    type={showpassword ? "text" : "password"}
                    placeholder="Password"
                    ref={passwordref}
                    onKeyDown={(e) => {
                      handleKeyDown(e);
                    }}
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      setError({ ...error, newPassword: "" });
                    }}
                  />
                  {showpassword ? (
                    <>
                      <Icon
                        icon="clarity:eye-show-line"
                        color="#E3D0A8"
                        width="32"
                        height="32"
                        className=" cursor-pointer"
                        onClick={() => {
                          setshowpassword(false);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Icon
                        icon="clarity:eye-hide-line"
                        color="#E3D0A8"
                        width="32"
                        className=" cursor-pointer"
                        height="32"
                        onClick={() => {
                          setshowpassword(true);
                        }}
                      />
                    </>
                  )}
                </div>
                {error.newPassword && (
                  <p className=" text-[#ff6839]  text-sm  text-center">
                    {error.newPassword}
                  </p>
                )}
                <div className=" ">
                  <div className="mb-4 input items-center  flex gap-3 border-2 !border-[#E3D0A8]  rounded-xl p-2 md:p-3 2xl:p-[22px] ">
                    {" "}
                    <img
                      src={Password_Icon}
                      className="w-4 h-4 md:h-auto md:w-auto"
                      alt=""
                    />
                    <input
                      className="border-none text-xl md:text-2xl text-black focus:outline-none p-0 focus:ring-0 w-full placeholder:text-[#E3D0A8]  md:placeholder:text-2xl "
                      type={showconfirmpassword ? "text" : "password"}
                      placeholder="Re-enter Password"
                      ref={confirmPasswordref}
                      value={confirmPassword}
                      onKeyDown={(e) => {
                        handleKeyDown(e);
                      }}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        setError({ ...error, confirmPassword: "" });
                      }}
                    />
                    {showconfirmpassword ? (
                      <>
                        <Icon
                          icon="clarity:eye-show-line"
                          color="#E3D0A8"
                          width="32"
                          height="32"
                          className=" cursor-pointer"
                          onClick={() => {
                            setshowconfirmpassword(false);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <Icon
                          icon="clarity:eye-hide-line"
                          color="#E3D0A8"
                          width="32"
                          className=" cursor-pointer"
                          height="32"
                          onClick={() => {
                            setshowconfirmpassword(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                  {error.confirmPassword && (
                    <p className=" text-[#ff6839]  text-sm  text-center">
                      {error.confirmPassword}
                    </p>
                  )}
                </div>

                <div className="">
                  <div
                    onClick={() => validateResetPassword()}
                    className={`bg-[#E3D0A8] text-center px-4 py-2.5 text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8] `}
                  >
                    Continue
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UserResetPassword;
